var _defs, _namedview;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgWeather(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 44,
    width: 40,
    id: "svg865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs869"
  })), _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    pageopacity: 0,
    pageshadow: 2,
    "window-width": 1866,
    "window-height": 1052,
    id: "namedview867",
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    zoom: 17.291667,
    cx: 20,
    cy: 24,
    "window-x": 54,
    "window-y": 0,
    "window-maximized": 1,
    "current-layer": "svg865"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g895",
    transform: "translate(-4,-4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 8.096386,
    rx: 18.130121,
    cy: 22.380724,
    cx: 23.913254,
    id: "path873",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66774356,
      strokeOpacity: 0.18518521
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 10.46747,
    rx: 9.9759035,
    cy: 16.019276,
    cx: 23.971085,
    id: "path877",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 0.18518521
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 5.66747,
    rx: 6.7373495,
    cy: 18.101204,
    cx: 12.925302,
    id: "path879",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 0.18518521
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 19.75,44 4.85,-5.5 -4,-2 5.65,-6.5 h 4 l -4.85,5.5 4,2 -5.65,6.5 z m -12,0 4.85,-5.5 -4,-2 5.65,-6.5 h 4 l -4.85,5.5 4,2 -5.65,6.5 z M 10.5,27 Q 6.15,27 3.075,23.925 0,20.85 0,16.5 0,12.55 2.825,9.45 5.65,6.35 9.85,6.05 11.45,3.25 14.075,1.625 16.7,0 20,0 24.55,0 27.625,2.875 30.7,5.75 31.4,10 35.35,10.2 37.675,12.675 40,15.15 40,18.5 40,22 37.525,24.5 35.05,27 31.5,27 Z m 0,-3 h 21 q 2.3,0 3.9,-1.625 Q 37,20.75 37,18.45 37,16.2 35.4,14.6 33.8,13 31.5,13 h -3 V 11.5 Q 28.5,7.95 26.025,5.475 23.55,3 20,3 17.45,3 15.325,4.375 13.2,5.75 12.2,8.1 L 11.8,9 H 10.4 Q 7.3,9.1 5.15,11.275 3,13.45 3,16.5 3,19.6 5.2,21.8 7.4,24 10.5,24 Z M 20,13.5 Z",
    id: "path863",
    style: {
      fill: "#e97a10",
      fillOpacity: 1
    },
    "connector-curvature": 0
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.7b75aa2addb9261a83919c79d201e97b.svg";
export { ForwardRef as ReactComponent };